const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center py-20">
      <h1 className="text-3xl font-bold">404</h1>
      <p className="mt-4 text-secondary">抱歉，您訪問的頁面不存在。</p>
    </div>
  );
};

export default NotFound;
